import React from 'react';
import styled from 'styled-components';

import Hoverable from 'components/basic/Hoverable/Hoverable';
import { CloseHeaderDropdownContext } from 'components/layout/header/closeHeaderDropdownContext';
import { menuItemPadding } from 'components/layout/header/commonStyles';

const HeaderDropdownLabelWrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  cursor: default;
`;

const DropdownContainer = styled.div<{ $leftAligned: boolean }>`
  display: flex;
  flex-direction: column;
  margin-top: -4px;
  position: absolute;

  border-radius: 4px;
  overflow: hidden;

  /* Above modals & Markets overlay */
  z-index: 199999;
  white-space: nowrap;
  ${({ $leftAligned }) => ($leftAligned ? 'left: 0;' : 'right:0;')}

  color: var(--white);
  border: 1px solid var(--gray1);
  background: var(--lighterBlack);
  font-size: var(--medium);
  line-height: 24px;
`;

const LinkTitle = styled.div<{
  $isActive: boolean;
  onClick?: unknown;
  $hoverColor?: string;
  $paddingRight?: string;
}>`
  ${menuItemPadding}
  display: flex;
  align-items: center;
  width: 100%;
  height: var(--header-height);
  cursor: pointer;
  transition: background-color 0.2s ease;
  color: ${({ $isActive }) => ($isActive ? 'var(--white)' : 'var(--gray4d)')};
  ${({ $hoverColor }) =>
    $hoverColor // var(--gray) / var(--gray2)
      ? `
    &:hover,
    &:active { background: ${$hoverColor}; }
  `
      : null}
  ${({ onClick }) => (onClick ? 'cursor: pointer;' : '')}
`;

const TooltipWrapper = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

export default function HeaderMenuDropdown({
  label,
  children,
  disableDropdown = false,
  tooltip,
  hoverColor,
  onHover,
  onLabelClick,
  // TODO: maybe okay to have all left aligned ? And we can remove this property
  leftAligned = true,
  paddingRight,
}: {
  label: React.ReactNode;
  children: React.ReactNode;
  disableDropdown?: boolean;
  tooltip?: React.ReactNode;
  hoverColor?: string;
  onHover?: (isHovered: boolean) => void;
  onLabelClick?: () => void;
  leftAligned?: boolean;
  paddingRight?: string;
}) {
  return disableDropdown ? (
    <HeaderDropdownLabelWrapper>
      <LinkTitle
        $isActive={false}
        onClick={onLabelClick}
        $hoverColor={hoverColor}
        $paddingRight={paddingRight}
      >
        {label}
      </LinkTitle>
    </HeaderDropdownLabelWrapper>
  ) : (
    <HeaderDropdownLabelWrapper>
      <Hoverable onHover={onHover}>
        {(active, close) => (
          <>
            <LinkTitle
              $isActive={active}
              onClick={onLabelClick}
              $hoverColor={hoverColor}
              $paddingRight={paddingRight}
            >
              {label}
            </LinkTitle>

            {active && (
              <DropdownContainer $leftAligned={!!leftAligned}>
                <CloseHeaderDropdownContext.Provider value={close}>
                  {children}
                </CloseHeaderDropdownContext.Provider>
              </DropdownContainer>
            )}
          </>
        )}
      </Hoverable>
      {tooltip && <TooltipWrapper>{tooltip}</TooltipWrapper>}
    </HeaderDropdownLabelWrapper>
  );
}
